import React from 'react';

import { IMcsaMapPoint } from '../../../../types/mcsa.interface';

interface JourneyExplorerProps {
    point: IMcsaMapPoint;
}

export const JourneyExplorer = (props: JourneyExplorerProps) => {
    const { point } = props;

    return (
        <div
            className='mcsa_journey_map__explorer'
            style={{ left: `${point.x * 100}%`, top: `${point.y * 100}%` }}
            aria-hidden='true'
        >
            <div className='mcsa_journey_map__explorer__bob'>
                <svg viewBox='0 0 48 60'>
                    <ellipse cx='24' cy='57' rx='12' ry='3' fill='rgba(74,48,109,.18)' />
                    <path d='M14 30 Q24 22 34 30 L33 46 Q24 50 15 46 Z' fill='#4A306D' />
                    <rect x='20' y='44' width='3.4' height='12' rx='1.5' fill='#5B6B7B' />
                    <rect x='24.6' y='44' width='3.4' height='12' rx='1.5' fill='#5B6B7B' />
                    <circle cx='24' cy='17' r='9' fill='#F3C9A6' />
                    <path d='M14 15 a10 10 0 0 1 20 0 l-2 -1 -3 2 -3 -2 -3 2 -3 -2 -3 1z' fill='#7A4B2B' />
                    <circle cx='21' cy='17' r='1.2' fill='#3a2a1e' />
                    <circle cx='27' cy='17' r='1.2' fill='#3a2a1e' />
                    <path d='M21.5 20.5 q2.5 2 5 0' stroke='#b06a3a' strokeWidth='1.3' fill='none' strokeLinecap='round' />
                    <path d='M31 28 l9 -4 1 3 -9 4z' fill='#C99A2E' />
                    <circle cx='41' cy='24' r='2.4' fill='#F0B429' />
                </svg>
            </div>
        </div>
    );
};
